import {
  require_buffer
} from "./chunk-XJTZ422K.js";
export default require_buffer();
